
import { computed, defineComponent, onUnmounted, Ref, watch } from 'vue';
import wishListsStore from '../wish-lists.store';
import pageStore from '@/shared/content/page.store';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import WishListItem from '@/b2c/wishlists/ui/WishListItem.vue';
import { useRouteQuery } from '@/core/browser/route-query.composable';
import { QueryKeys } from '@/shared/config/route-query.config';
import { useRoute } from 'vue-router';
import NativeShareButton from '@/shared/NativeShareButton.vue';
import WishListShareButton from '@/b2c/wishlists/ui/WishListShareButton.vue';
import basketTrackingService from '@/shared/tracking/basket-tracking.service';

export default defineComponent({
    name: 'WishListShared',
    components: { WishListShareButton, NativeShareButton, WishListItem },
    setup() {
        const labels = useBlockLabels();
        const id = useRouteQuery(QueryKeys.Id);
        const route = useRoute();

        const details = computed(() => {
            return wishListsStore.shared;
        });

        const shareUrl = computed(() => {
            return `${location.origin}${route.fullPath}`;
        });

        const listDefaultImageUrl: Ref<string | undefined> = computed(() => {
            return wishListsStore.getDetailsShareImageUrl(details.value);
        });

        const hasWishListItems = computed(() => {
            return details.value.wishListItems && details.value.wishListItems.length > 0;
        });

        const hasWishListItemsForPurchase = computed(() => {
            return details.value.purchasableProducts && details.value.purchasableProducts.length > 0;
        });

        const updatePageAltTitle = (): void => {
            pageStore.setAltTitle(wishListsStore.shared.name);
        };

        const updateShared = (): void => {
            wishListsStore.updateShared(id.value).then(updatePageAltTitle);
        };

        const trackAddListToBasket = () => {
            basketTrackingService.wishlistAll(details.value, true);
        };

        onUnmounted(() => {
            wishListsStore.clearShared();
            pageStore.clearAltTitle();
        });

        watch(() => id, (newQuery) => {
            if (id.value) {
                updateShared();
            }
        }, { immediate: true });

        return {
            labels,
            details,
            hasWishListItems,
            hasWishListItemsForPurchase,
            listDefaultImageUrl,
            shareUrl,
            trackAddListToBasket,
        };
    },
});
